export default {
  clients: [],
  certificates: {},
  tools: {}
};
